<template>
    <v-dialog
      v-model="isSuccessed"
      persistent
      max-width="700"
    >
      <v-card>
         <v-card-text class="text-center">
            <div><v-icon class="my-5" color="teal darken-1" x-large>mdi-checkbox-marked-circle</v-icon></div>
            <p v-html="successText"></p>
            <div class="my-3 text-left">
              <v-card outlined max-width="90%" class="mx-auto" color="primary lighten-5">
                <v-card-title>
                  <v-icon class="mr-1" color="primary">mdi-information</v-icon>
                  <span class="title font-weight-light">送付していただく分析依頼品についてのお願い</span>          
                </v-card-title>
                <v-card-text class="body-2 black--text">
                  「お申込書」を分析依頼物に同梱して弊社まで送付してください。
                  <br>
                  分析サンプルのボトルには「サンプルバーコード」を貼り付けてください。<br>
                </v-card-text>
              </v-card>
              <br>
              <v-card v-show="hasHazardousMaterials" outlined max-width="90%" class="mx-auto" color="amber lighten-5">
                <v-card-title>
                  <v-icon class="mr-1" color="red">mdi-information</v-icon>
                  <span class="title font-weight-light">危険物が含まれる分析サンプルがあります。</span>          
                </v-card-title>
                <v-card-text class="body-2 black--text">
                「安全データシート」など、分析サンプルに含まれる危険物に関する資料を分析依頼品に忘れずに同梱してください。<br>
                </v-card-text>
              </v-card>
            </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="teal darken-1"
            rounded
            outlined
            @click="showDialog()"
            class="mb-5"
          >
            お申込みページに戻る
          </v-btn>
          <v-btn
            color="amber darken-1"
            rounded
            @click="gotoOrderSheet"
            class="mb-5 mr-3"
          >
            <span class="px-2">
              <v-icon small>mdi-file</v-icon>
              分析・診断サービス申込書を印刷
            </span>
          </v-btn>
<!--
            :to="{ path: 'ordersheet4labelsheet/', query: { id: id }}"
-->
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>
<script>
export default {
    props:["successUrl","successText"],
    data: () => ({
        isSuccessed: false,
        id: "",
        hasHazardousMaterials: false,
        analizeTypeCategory: ""
    }),
    methods: {
      showDialog() {
          this.isSuccessed = false
//          this.$router.back()
          this.$router.push(this.successUrl)
      },
      open(ifjson) {
        console.log('result from modal:', ifjson)
        this.id = ifjson.id
        this.hasHazardousMaterials = ifjson.hasHazardousMaterials
        this.analizeTypeCategory = ifjson.analizeTypeCategory
        
        this.isSuccessed = true
      },
      gotoOrderSheet: function() {
        // 一般の分析依頼の場合
        if(this.analizeTypeCategory == "一般") {
          this.$router.push("/ordersheet4labelsheet?id=" + this.id)
        // 一般以外（JET）の分析依頼の場合
        }else {
          this.$router.push("/ordersheet4labelsheetJET?id=" + this.id)
        }
      },
    }
}
</script>

